import React from "react";
import { Grid } from "@mui/material";
import SubHeader from "components/subHeader/SubHeader";
import CustomerCarousel from "pages/customers/CustomerCarousel";

function ProfileVendor(props) {
  const onSubmittBtn = (data, code) => {
    props.onSubmittBtn(data, code);
  };
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className="profilevendorMain"
      >
        <SubHeader
          details={props?.details}
          type={props?.type}
          onClickStatusIcon={props?.onClickStatusIcon}
          loader={props?.loader}
          statusChange={props?.statusChange}
        />
        {/* ---2nd section--- */}
        <CustomerCarousel
          type={props?.type}
          onSubmittBtn={onSubmittBtn}
          onDelete={props.onDelete}
          details={props.details}
          editData={props.editData}
          loader={props?.loader}
          editButton={props?.editButton}
        />
      </Grid>
    </div>
  );
}

export default ProfileVendor;
